import { createContext, useContext, useState, useCallback, ReactNode } from 'react';

interface LayoutContextType {
  isFullHeight: boolean;
  setFullHeight: (value: boolean) => void;
}

const LayoutContext = createContext<LayoutContextType | null>(null);

export function LayoutProvider({ children }: { children: ReactNode }) {
  const [isFullHeight, setIsFullHeight] = useState(false);

  const setFullHeight = useCallback((value: boolean) => {
    setIsFullHeight(value);
  }, []);

  return (
    <LayoutContext.Provider value={{ isFullHeight, setFullHeight }}>
      {children}
    </LayoutContext.Provider>
  );
}

export function useLayout() {
  const context = useContext(LayoutContext);
  if (!context) {
    throw new Error('useLayout must be used within a LayoutProvider');
  }
  return context;
}
